/**
 * @author lifei
 * 功能：异步延迟
 */
export const delay = (ms: number = 30): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms))
